import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const LoginRegister = () => {
  const { login, register } = useAuth();
  
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const toggleForm = () => {
    setIsLogin(!isLogin);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const result = isLogin 
        ? await login(email, password)
        : await register(email, password);
      
      if (!result.success) {
        setError(result.message || 'Authentication failed');
        return;
      }
      
      window.location.reload();
      
    } catch (err) {
      setError('An error occurred: ' + err.message);
      console.error('Auth error:', err);
    }
  };

  return (
    <div className="login-register">
      <form onSubmit={handleSubmit}>
        <input 
          type="email" 
          placeholder="Email" 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required 
        />
        <input 
          type="password" 
          placeholder="Password" 
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required 
        />
        <button type="submit">{isLogin ? 'Login' : 'Register'}</button>
      </form>
      {error && <div className="error-message">{error}</div>}
      <button className="toggle-button" onClick={toggleForm}>
        {isLogin ? 'Switch to Register' : 'Switch to Login'}
      </button>
    </div>
  );
};

export default LoginRegister;
